import { GET_EXTRAS, SET_EXTRAS } from './action-types';
import { getRequestStatus } from '../../requests/selectors';

export const [isFetchingSelector, hasErrorFetchingSelector, errorDataFetchingSelector] = getRequestStatus(GET_EXTRAS);
export const [isSavingSelector, hasErrorSavingSelector, errorDataSavingSelector] = getRequestStatus(SET_EXTRAS);

export const extrasSelector = (state) => state.booking.extras.extras;
export const showDiscountBoxSelector = (state) => state.booking.extras.showDiscountBox === 'true';
